// filters
$.expr[':'].external = function (obj) {
    'use strict';
    try {
        if (obj.href) {
            return !obj.href.match(/^mailto:/) && (obj.hostname != location.hostname);
        }
        return false;
    } catch (e) {
        return false;
    }
};
$.expr[':'].download = function (obj) {
    'use strict';
    try {
        if (obj.href) {
            var href = obj.href.split("?")[0]
            return (href.match(/\.(pdf|doc|docx|xls||xlsx|cvx|jpg|gif|mp3|swf|txt|ppt|zip|gz|dmg)$/) !== null);
        }
        return false;
    } catch (e) {
        return false;
    }
};
$.expr[':'].image = function (obj) {
    'use strict';
    try {
        if (obj.href) {
            return (obj.href.match(/\.(jpg|png|jpeg|JPG|PNG)$/) !== null);
        }
        return false;
    } catch (e) {
        return false;
    }
};

$(document).ready(function () {
    'use strict';
    // enllaços externs en finestra nova
    $('a:external, a[rel=external]').attr('target', '_blank').addClass('external').attr('rel', 'external noreferrer');
    $('a:download, a[rel=document]').attr('target', '_blank').addClass('document').attr('rel', 'document');

    // enllaç al pare (per iframes, etc..)
    $('a[rel=parent]').attr('target', '_parent');

    // evitem spam als correus
    $("a[href*='(ELIMINAR)']").each(function () {
        var t = $(this);
        var omg = t.attr('href');
        var omg2 = t.html();
        t.attr('href', omg.replace('(ELIMINAR)', ''));
        t.html(omg2.replace('(ELIMINAR)', ''));
    });

    // protecció antispam
    $('input[name="houdiniControl"]').remove();

    // identifiquem el primer i l'últim element de les llistes
    // $('ul, ol').each(function () {
    //     var t = $(this);
    //     t.children('li:first').addClass('first');
    //     t.children('li:last').addClass('last');
    // });

    // popups
    $('.popup').magnificPopup({
        type: 'image'
    });

    $('.gallery__item').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    //$('a[href*="youtube.com"]').attr('class', 'popup-youtube');


    $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
        patterns: {
        // Evita que el patró per defecte torni a processar la URL de l'embed
        youtube: { index: 'youtube.com/watch' }
        }
    },
    callbacks: {
        elementParse: function (item) {
        var url = item.src;
        var idMatch = url.match(/[?&]v=([^&#]+)/) || url.match(/youtu\.be\/([^?&#]+)/);
        if (!idMatch) return;

        var start = 0;
        var t = url.match(/[?&](?:t|start)=([^&#]+)/);
        if (t) {
            var p = t[1].match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/);
            if (p) {
            start = (parseInt(p[1] || 0) * 3600) +
                    (parseInt(p[2] || 0) * 60) +
                    parseInt(p[3] || 0);
            }
        }

        item.src = 'https://www.youtube.com/embed/' + idMatch[1] +
                    '?autoplay=1' + (start ? '&start=' + start : '');
        }
    }
    });



    $('.popup-video').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
            open: function () {
                this.content.find('video').get(0).play();
            },
            beforeClose: function () {
                var video = this.content.find('video').get(0);
                video.pause();
                video.currentTime = 0;
            }
        }
    });


    // if ($('.infinite-paginator-button-wrapper').length) {
    //     $(document).on('click', '.infinite-paginator-button-wrapper a', function (e) {


    //         $(this).parent().remove();

    //         var listURL = $(this).attr('href');
    //         $.ajax(
    //             {
    //                 url: listURL,
    //                 type: "GET",
    //                 success: function (data, textStatus, jqXHR) {
    //                     $(this).parent().remove();
    //                 },
    //                 error: function (jqXHR, textStatus, errorThrown) {

    //                 }
    //             });
    //         e.preventDefault(); //STOP default action
    //     });
    // }
});
